import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoEsquemaComponent {
  catalogos = {
    esquemas: []
  }
  data
  esquema
  eliminando = false
  idProyecto
  modificando = false

  constructor ($state, ViaticosCatalgosProyectoEsquemasService) {
    this.$state = $state
    this.ViaticosCatalgosProyectoEsquemasService = ViaticosCatalgosProyectoEsquemasService
  }

  $onInit () {
    this.promise = this.ViaticosCatalgosProyectoEsquemasService.get(this.idProyecto)
      .then(({data}) => (this.catalogos.esquemas = data))
      .finally(() => (this.obtenerEsquema()))
  }

  editar (data) {
    this.data = data
    this.obtenerEsquema()
    this.modificando = false
  }

  obtenerEsquema () {
    this.esquema = this.catalogos.esquemas.find((esquema) => esquema.id === this.data.esquema_id) || null
    this.esquemaAsimilado = this.catalogos.esquemas.find((esquema) => esquema.id === this.data.esquema_asimilado_id) || null
  }

  regresar () {
    this.$state.go('.^')
  }

}

module.component('viaticosConfiguracionProyectoEsquema', {
  controller: ViaticosConfiguracionProyectoEsquemaComponent,
  template,
  bindings: {
    idProyecto: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/esquema/component.js